export default "__VITE_ASSET__CR$grJLR__"